/*
	
	Use this file to provide customizations to the config.js module. Putting your settings in this file is update-save
	(they won't be overwritten by future updates).

	Making changes directly to config.js is riskt, as those changes are at risk of being overwritten by future updates.

	When providing custom settings, be sure copy the entire entry from the config.js module, as such:

	module.exports.inputAppend = ['font-size', 'margin-top', 'margin-bottom', 'margin-left', 'margin-right', 'padding-top', 'padding-bottom', 'padding-left', 'padding-right', 'height', 'width'];

	Providing only parts of a config module will likely break the application

*/

(function () {
	"use strict";

	// module.exports.inputAppend = ['font-size', 'margin-top', 'margin-bottom', 'margin-left', 'margin-right', 'padding-top', 'padding-bottom', 'padding-left', 'padding-right', 'height', 'width'];

}());


// WEBPACK FOOTER //
// ./assets/js/modules/config_custom.js